<template>
  <b-form-group
    class="sid-range mb-2"
    :label="label"
  >
    <div class="flex items-center gap-[17px] justify-between">
      <vue-slider
        v-model="sizeMutated"
        :interval="step"
        :max="getDimensionValue.max"
        :min="getDimensionValue.min"
        class="editor-slider-1 w-100"
        tooltip="none"
        @change="onChange($event, dimension)"
      />

      <div :class="dimensions.length > 1 ? 'mt-[-26px]' : 'mt-[-10px]'">
        <div
          v-if="dimensions.length > 1"
          class="flex gap-[7px] text-[#A6A6A6] text-uppercase text-[11px] font-[600] mb-[11px]"
        >
          <span
            v-for="dim in dimensions"
            :key="dim"
            class="cursor-pointer hover:text-[#44474A]"
            :class="{'text-[#44474A]': dimension === dim}"
            @click="onChangeDimension(dim)"
            v-text="dim"
          />
        </div>

        <LinkedControlItem
          v-model="sizeMutated"
          :step="step"
          :ignore-zero="false"
          :max="getDimensionValue.max"
          :min="getDimensionValue.min"
          delay
          class="d-block !w-[57px] !text-[#7E7E7E] !text-[13px] !h-[29px]"
          :placeholder="sidValueMutation === 'auto' ? 'auto' : '-'"
          @input="onChange($event, dimension)"
        />
      </div>
    </div>
    <div class="flex justify-end pt-2">
      <span
        class="text-[13px] text-[#44474A] hover:opacity-80 cursor-pointer underline"
        @click="onReset"
      >
        Reset
      </span>
    </div>
  </b-form-group>
</template>

<script>
import shortid from 'shortid'
import SidConcept from '@/components/mixins/SidConcept'
import LinkedControlItem from '@/components/editor/components/linked-control-group/LinkedControlItem'

export default {
  name: 'SidFontSize',
  components: {LinkedControlItem},
  mixins: [SidConcept],
  props: {
    label: {
      type: String,
      default: 'Font Size'
    },
    ruleName: {
      type: String,
      default: 'font-size'
    },
    selected: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      size: '',
      dim: '',
      dimensions: ['px', 'rem'],
      touched: false,
      timeout: null
    }
  },
  computed: {
    resolution () {
      return this.$store.state.editor.resolution
    },
    step () {
      switch (this.dimension) {
      case 'px':
        return 1
      case 'rem':
        return 0.25
      default:
        return 1
      }
    },
    getDimensionValue () {
      switch (this.dimension) {
      case 'px':
        return { max: 320, min: 0 }
      case 'rem':
        return { max: 20, min: 0 }
      default:
        return { max: 320, min: 0 }
      }
    },
    dimension: {
      get () {
        const val = this.selected?.sid
          ? this.getSidStyle(`.--${this.selected.sid}-text-size`, this.ruleName)
          : this.sidValueMutation
        const regx = /(\d+(?:\.\d+)?)(px|%|rem|vh|vw)/.exec(val) || []
        return regx.length >= 3 ? regx[2] : ''
      },
      set (dim) {
        this.dim = dim
      }
    },
    sizeMutated: {
      get () {
        const val = this.selected?.sid
          ? this.getSidStyle(`.--${this.selected.sid}-text-size`, this.ruleName)
          : this.sidValueMutation
        const regx = /(\d+(?:\.\d+)?)(px|%|rem|vh|vw)/.exec(val) || []
        return regx.length >= 3 ? regx[1] : ''
      },
      set (val) {
        this.size = val
      }
    }
  },
  methods: {
    apply (val, dimension) {
      if (this.selected?.sid) {
        this.addSidRules([[`.--${this.selected.sid}-text-size`, [this.ruleName, `${val}${dimension || this.dimension}`]]])
      } else {
        this.addSidRules([[this.getSid(), [this.ruleName, `${val}${dimension || this.dimension}`]]])
      }
    },
    reset () {
      this.dimension = ''
      this.sizeMutated = ''
      if (this.selected?.sid) {
        this.addSidRules([[`.--${this.selected.sid}-text-size`, [this.ruleName, this.defaultValue]]])
      } else {
        this.addSidRules([[this.getSid(), [this.ruleName, this.defaultValue]]])
      }
    },
    onChangeDimension (val) {
      this.dimension = val
      if (val === 'rem') {
        this.onChange(1, 'rem')
      } else {
        this.onChange(16, 'px')
      }
    },
    onChange (val, dimension) {
      let spanSid = ''

      if (this.selected?.sid) {
        spanSid = this.selected.sid
      } else {
        spanSid = shortid.generate()
      }

      this.$emit('onChange', {
        value: `${val}${dimension}`,
        sid: spanSid,
        apply: () => this.apply(val, dimension)
      })
    },
    onReset () {
      this.$emit('onReset', {
        reset: () => this.reset()
      })
    }
  }
}
</script>
